import { MESSAGES } from './constants';

const REDIRECT_URI = `${window.location.origin}/login/callback`;
const {
  NODE_ENV,
  REACT_APP_OKTA_ISSUER,
  REACT_APP_OKTA_CLIENT_ID,
  REACT_APP_API_ENDPOINT,
  REACT_APP_API_STAGE,
  REACT_APP_API_VERSION,
  REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK,
  REACT_APP_CLOUDFRONT_URL,
  REACT_APP_LOG_API_ENDPOINT,
  REACT_APP_LOG_API_KEY,
  REACT_APP_UPLOAD_API_ENDPOINT,
  REACT_APP_PACKAGE_UPLOAD_API_ENDPOINT,
  REACT_APP_PACKAGE_DOWNLOAD_API_ENDPOINT,
  REACT_APP_SHOW_ANNOUNCEMENT
} = process.env;

const { errorMessage, systemNotificationMessage } = MESSAGES;

export default {
  envi: NODE_ENV,
  oidc: {
    clientId: REACT_APP_OKTA_CLIENT_ID,
    issuer: REACT_APP_OKTA_ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK,
    cookies: {
      secure: true
    }
  },
  resourceServer: {
    messagesUrl: 'http://localhost:3000/api/messages'
  },
  api: {
    endpoint: `${REACT_APP_API_ENDPOINT}/${REACT_APP_API_STAGE}/${REACT_APP_API_VERSION}`
  },
  logService: {
    endpoint: REACT_APP_LOG_API_ENDPOINT,
    apiKey: REACT_APP_LOG_API_KEY
  },
  uploadService: {
    image: {
      endpoint: REACT_APP_UPLOAD_API_ENDPOINT
    },
    package: {
      endpoint: REACT_APP_PACKAGE_UPLOAD_API_ENDPOINT
    }
  },
  downloadService: {
    package: {
      endpoint: REACT_APP_PACKAGE_DOWNLOAD_API_ENDPOINT
    }
  },
  assets: {
    image_path: REACT_APP_CLOUDFRONT_URL,
    package_path: REACT_APP_CLOUDFRONT_URL
  },
  storageKeys: {
    user: 'bootstrapper-user'
  },
  errorMessage,
  systemNotification: {
    show: REACT_APP_SHOW_ANNOUNCEMENT === 'true',
    type: 'warning',
    message: systemNotificationMessage
  },
  hcArticles: {
    validateSubscription: {
      title: 'Invalid Instance Add-Ons Error',
      link:
        'https://z3n-bootstrapper.zendesk.com/hc/en-us/articles/4407699331092-Invalid-Instance-Add-Ons-Error'
    }
  }
};
